<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.account_address"
        :primary-fields="[ 'code', 'name', 'postcode', 'state', 'contact', 'phone', 'email' ]"
        @apply="$refs.table.loadTable()"
        @ready="$refs.table.loadTable()"
        @sort="sort = $event; $refs.table.loadTable()"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        shadow="never"
      >
        <AddressesTable
          ref="table"
          :filters="filters"
          :sort="sort"
          :account-id="$route.params.accountId"
          :is-show.sync="isShowPreview"
          :is-show-import.sync="isShowImport"
        />
      </el-card>
    </el-col>
    <Preview
      v-if="isShowPreview"
      title="Address Book Export"
      :is-show.sync="isShowPreview"
      :configuration="configuration"
    />
    <AddressImportForm
      v-if="isShowImport"
      :is-show.sync="isShowImport"
      :account-id="this.$route.params.accountId"
    />
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Simplified'
import AddressesTable from '@/components/Application/Manage/Account/AddressesTable'
import Preview from '@/components/Application/Reports/Preview'
import AddressImportForm from '@/components/Application/Manage/Account/AddressImportForm'

export default {
  components: {
    Filters,
    AddressesTable,
    Preview,
    AddressImportForm
  },
  data () {
    return {
      actions: [],
      breadcrumb: {
        name: 'Address Book',
        route: { name: 'manage-accounts-account-addresses', params: { accountId: this.$route.params.accountId } }
      },
      filters: [],
      isShowPreview: false,
      isShowImport: false,
      configuration: {
        report: 'Addressbook',
        params: {
          accountId: this.$route.params.accountId,
          showChildrenAccts: false
        }
      },
      sort: {
        field: 'created_at',
        direction: 'desc'
      }
    }
  },
  mounted () {
    this.actions = this.$refs.table.actions
  }
}
</script>
